<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <!-- <span class="countryName"></span> -->
          <el-input placeholder="输入关键字模糊查询" v-model="keywordQuery" clearable></el-input>
        </div>

        <el-dialog title="新建大屏配置 " :visible.sync="dialogBigScreen">
          <el-form :model="formBigScreen">
            <el-form-item label="大屏名称" :label-width="formLabelWidth">
              <el-input v-model="formBigScreen.bigScreenName" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogBigScreen = false">取 消</el-button>
            <el-button type="primary" @click="addBigScreen()">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 属性设置 -->
        <el-dialog title="大屏属性详情 " :visible.sync="settingsDialog">
          <el-form :model="settingData">
            <el-form-item label="大屏名称：" :label-width="formLabelWidth">
              <el-input v-model="settingData.board_name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="链接：" :label-width="formLabelWidth">
              <el-input v-model="settingData.url" placeholder="请输入dataV链接"></el-input>
            </el-form-item>
            <el-form-item label="大屏包含地区：" :label-width="formLabelWidth">
              <el-row>
                <el-col :span="5">
                  全球
                  <el-switch
                    :inactive-value= 0
                    :active-value= 1
                    v-model="settingData.area_turn"
                    @change="areaTurnFn"
                  >
                  </el-switch>
                </el-col>
                <el-col :span="10" v-if="settingData.area_turn == 0">
                  <el-select  v-model="settingData.area_id_arr" filterable multiple collapse-tags placeholder="请选择地区" clearable>
                    <el-option
                      v-for="item in settingArea"
                      :key="item.id"
                      :label="item.area_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>

            <!-- 2021.11.03 新增（海外湘企管理平台） -->
            <div style="display:flex;">
              <el-form-item label="所属分类：" :label-width="formLabelWidth">
                <el-select
                  v-model="settingData.board_category_id_arr"
                  filterable
                  multiple
                  collapse-tags
                  placeholder="请选择">
                  <el-option
                    v-for="item in board_category_list"
                    :key="item.id"
                    :label="item.board_category_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="定制单位：" :label-width="formLabelWidth">
                <el-input v-model="settingData.company_name" placeholder="请输入定制单位"></el-input>
              </el-form-item>
            </div>

            <el-form-item label="主风险字段：" :label-width="formLabelWidth">
              <el-input v-model="settingData.risk_field_name" placeholder="请输入主风险字段"></el-input>
            </el-form-item>

            <el-form-item label="SCREENID：" :label-width="formLabelWidth">
              <el-input v-model="settingData.datav_screenid" placeholder="请输入SCREENID"></el-input>
            </el-form-item>

            <el-form-item label="TOKEN：" :label-width="formLabelWidth">
              <el-input v-model="settingData.datav_token" placeholder="请输入TOKEN"></el-input>
            </el-form-item>
            <!-- 2020.7.2 v1.4新增 -->
            <el-form-item label="大屏封面:" :label-width="formLabelWidth">
                <div v-if="this.settingData.cover" style="margin-bottom: 10px;">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="this.settingData.cover"
                    fit="fill"
                    :preview-src-list="[this.settingData.cover]"
                  >
                  </el-image>
                </div>
                <div>
                  <el-upload
                    :action="imageUrl"
                    accept="image/*"
                    :show-file-list="false"
                    :data="imageData"
                    name="file"
                    v-model="settingData.cover"
                    :on-success="handleUploadSuccess"
                  >
                    <el-button size="small" type="primary">点击上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>

            <el-form-item label="是否有公告：" :label-width="formLabelWidth">
              <el-row>
                <el-col :span="10">
                  <el-switch
                    :inactive-value= 0
                    :active-value= 1
                    v-model="settingData.have_notice"
                  >
                  </el-switch>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="关联企业：" :label-width="formLabelWidth">
              <el-select
                v-model="settingData.company_ids_arr"
                filterable
                multiple
                collapse-tags
                placeholder="请选择">
                <el-option
                  v-for="item in companyArr"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="启用状态：" :label-width="formLabelWidth">
              <el-row>
                <el-col :span="10">
                  <el-switch
                    :inactive-value= 0
                    :active-value= 1
                    v-model="settingData.status"
                  >
                  </el-switch>
                </el-col>
              </el-row>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="settingsDialog = false">取 消</el-button>
            <el-button type="primary" @click="settingEdit">确 定</el-button>
          </div>
        </el-dialog>


        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary" @click="dialogBigScreen = true ">新建大屏配置</el-button>
          </el-row>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="id" label="大屏编号"></el-table-column>
        <el-table-column prop="board_name" label="大屏名称"></el-table-column>
        <el-table-column prop="add_time" label="创建时间" :formatter="addTime" sortable></el-table-column>
        <!-- <el-table-column prop="update_time" label="最后修改时间" :formatter="updateTime" sortable></el-table-column> -->
        <el-table-column prop="last_admin_username" label="操作人">
          <template slot-scope="scope">
            <span>{{scope.row.last_admin_username || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" size="small" @click="settingsFn(scope.row)">
                <i class="el-icon-seting"></i>属性设置
              </el-button>
              <el-button type="text" size="small" @click="bigScreenDetails(scope.row)">
                <i class="el-icon-edit"></i>编辑
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"
import tokenService from "@/utils/services/token_service";
import lodash from '../../../utils/tools/lodash';
export default {
  mixins: [timestampToTime],
  name: "CountryBase",
  data() {
    return {
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "board"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      fileList: [], //文件列表
      keywordQuery: "",
      addressItem: null,
      countryName: "",
      tableData: [],
      currentPage: 1,
      totalList: null,
      dialogBigScreen: false,
      settingsDialog: false,
      formLabelWidth: "120px",
      formBigScreen: {
        bigScreenName: "",
        bigScreenAreaId: ""
      },
      settingData: {
        have_notice: 1,
        // company_ids_arr: []
      },
      settingArea: [],
      companyArr: [],
      getDataParams: {
        showall: 1, 
        status: -1 ,
        pagesize: 10,
        page: 1
      },
      board_category_list: [],
    };
  },
  created() {
    this.getData()
    this.settingDataFn()
    this.companyFn()
    this.getConfigCategoryList()
  },
  methods: {
    // select地区列表
    settingDataFn() {
      let datas = {
        pagesize: 9999
      }
      api
        .adminAreaList(datas)
        .then(res => {
          console.log(res)
          this.settingArea = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },
    // select项目列表
    companyFn() {
      let datas = {
        pagesize: 9999
      }
      api
        .companyList(datas)
        .then(res => {
          this.companyArr = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    //地区选择
    areaTurnFn(val) {
      console.log(val)
    },
    // 获取数据
    getData() {
      api
        .getBigScreenList(this.getDataParams)
        .then(res => {
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
        })
        .catch(err => {
          this.$message(err);
        });
    },
    // 新建大屏配置
    addBigScreen() {
      this.dialogBigScreen = true;
      let data = {
        board_name: this.formBigScreen.bigScreenName
      };
      api
        .addBigScreenData(data)
        .then(res => {
          this.$message("新增字段成功");
          this.getData();
          this.dialogBigScreen = false;
          this.formBigScreen = {};
        })
        .catch(err => {
          this.$message(err);
        });
    },
    // 编辑操作
    bigScreenDetails(row) {
      let routeData = this.$router.resolve({
        name: "BigScreenData",
        query: {
          BigScreenName: row.board_name,
          configId: row.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    // 2023.4.14新增查询
    queryData() {
      this.currentPage = 1
      this.getDataParams.page = 1
      this.getDataParams.q = this.keywordQuery
      api
        .getBigScreenList(this.getDataParams)
        .then(res => {
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
        })
        .catch(err => {
          this.$message(err);
        });
    },
    // 图片上传成功
    handleUploadSuccess(res, file) {
      console.log('dsdsdsdsds')
      this.settingData.cover = res.file
    },
    // 属性设置
    settingsFn(row) {
      this.settingData = {}
      this.settingsDialog = true
      this.settingData = row
      let listArr = []
      let categoryArr = []
      if(row.company_list.length > 0) {
        row.company_list.forEach(item => {
          listArr.push(item.id)
        });
        this.$set(this.settingData,'company_ids_arr',listArr)
      }
      // 大屏类型
      if(row.board_config_category.length > 0) {
        row.board_config_category.forEach(item => {
          categoryArr.push(item.board_category_id)
        });
        this.$set(this.settingData,'board_category_id_arr',categoryArr)
      }
      if(row.area_id == "0") {
        this.$set(this.settingData,'area_turn',1)
      }else {
        this.$set(this.settingData,'area_id_arr',row.area_id.split(',').map(Number))
      }
    },
    // 属性设置编辑
    settingEdit() {
      if(this.settingData.area_turn == 1) {
        this.settingData.area_id = 0
      }else {
        if(this.settingData.area_id_arr.length > 0) {
          this.settingData.area_id = this.settingData.area_id_arr.join(',')
        }
      }
      if(this.settingData.company_ids_arr){
        this.$set(this.settingData,'company_ids',this.settingData.company_ids_arr.join(','))
      }
      if(this.settingData.board_category_id_arr){
        this.$set(this.settingData,'board_category_id',this.settingData.board_category_id_arr.join(','))
        // console.log(this.settingData.board_category_id)
      }
      api
        .settingEdit(this.settingData)
        .then(res => {
          if(res.error_code == 0) {
            this.settingsDialog = false
            this.getData()
            this.$message.success("大屏属性设置成功！");
          }
        })
        .catch(err => {
          // this.$message.error(err.error_message);
        });
    },
    // 分页 下拉选择pagesize
    handleSizeChange(val){
      // console.log(val);
      this.getDataParams.pagesize = val
      this.getData()
    },
    // 分页 点击选择page
    handleCurrentChange(val){
      // console.log(val);
      this.currentPage = val
      this.getDataParams.page = val
      this.getData()
    },
    // 大屏列表
    async getConfigCategoryList() {
      let res = await api.boardConfigCategoryList()
      this.board_category_list = res.data
    },
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>